"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importStar(require("react"));
const hooks_1 = require("../../hooks");
const OsmosysLogTerminal_1 = require("../../../../comps/OsmosysLogTerminal");
const useLogsReducer_1 = require("../../../../comps/OsmosysLogTerminal/useLogsReducer");
const template_parser_1 = require("@osmosys/template-parser");
const react_use_1 = require("react-use");
const react_loops_1 = require("react-loops");
const reactstrap_1 = require("reactstrap");
const react_hooks_1 = require("@apollo/react-hooks");
const graphql_1 = require("../../../../graphql");
const react_router_dom_1 = require("react-router-dom");
const utils_1 = require("@osmosys/utils");
const utils_2 = require("../../../../panels/ContentImportPanel/utils");
const debug_1 = require("../../../../debug");
const getRefreshableBlocks = (blocks, idxPath) => {
    return blocks.reduce((acc, b, i) => {
        const isRefreshable = template_parser_1.emailTemplateBlockIs(b, 'refreshable', false, true);
        if (isRefreshable) {
            return [...acc, { idxPath: idxPath ? [...idxPath, i] : [i], obj: b }];
        }
        return [...acc, ...getRefreshableBlocks(b.childBlocks)];
    }, []);
};
const useRefreshableBlocks = (blocks, skip = false) => {
    return react_2.useMemo(() => {
        if (skip) {
            return [];
        }
        const newBlocks = getRefreshableBlocks(blocks);
        return newBlocks;
    }, [skip, blocks]);
};
const useUniqueContentFeedsFromBlocks = (blocks, skip = false) => {
    return react_2.useMemo(() => {
        if (skip) {
            return [];
        }
        const contentFeedsObj = blocks.reduce((acc, b) => {
            if (!b.obj.contentFeed || typeof b.obj.contentSlotNumber !== 'number') {
                return acc;
            }
            const existingMeta = acc[b.obj.contentFeed.id];
            return Object.assign(Object.assign({}, acc), { [b.obj.contentFeed.id]: {
                    blocks: existingMeta ? [...existingMeta.blocks, b] : [b],
                    obj: b.obj.contentFeed,
                    slots: [
                        ...new Set(existingMeta
                            ? [...existingMeta.slots, b.obj.contentSlotNumber]
                            : [b.obj.contentSlotNumber]),
                    ],
                } });
        }, {});
        return Object.values(contentFeedsObj);
    }, [skip, blocks]);
};
exports.EmailCanvasRefreshContentModal = () => {
    const { query } = react_hooks_1.useApolloClient();
    const { data: { contentRefreshModalIsOpen, draftEmail }, update, } = hooks_1.useEmailCanvasCanvas('state');
    const blocks = draftEmail.blocks || [];
    const [modalIsShowing, toggleModalIsShowing] = react_use_1.useToggle(contentRefreshModalIsOpen);
    const prevModalIsShownig = react_use_1.usePrevious(modalIsShowing);
    const prevContentRefreshModalIsOpen = react_use_1.usePrevious(contentRefreshModalIsOpen);
    //   const [isReady] = useTimeout(2000);
    //   const ready = isReady();
    const [status, setStatus] = react_2.useState('notRunning');
    const running = status === 'loading';
    const prevStatus = react_use_1.usePrevious(status);
    const prevRunning = prevStatus === 'loading';
    const blocksToRefresh = useRefreshableBlocks(blocks, !modalIsShowing);
    const contentFeeds = useUniqueContentFeedsFromBlocks(blocksToRefresh, !modalIsShowing);
    const blocksToRefreshCount = blocksToRefresh.length || 0;
    const contentFeedsLength = contentFeeds.length || 0;
    const canRun = blocksToRefreshCount > 0 && contentFeedsLength > 0;
    //   const [getContentItems, contentItemsResult] = useLazyQuery<{
    //     contentItems: IContentItem[];
    //   }>(contentItems, {
    //     variables: {
    //       //   contentFeedId: contentFeed && contentFeed.id,
    //     },
    //   });
    //   const prevCanRun = usePrevious(canRun);
    //   const prevBlocksToRefreshCount = usePrevious(blocksToRefreshCount);
    //   const prevReady = usePrevious(ready);
    const [logs, dispatch] = useLogsReducer_1.useLogsReducer([]);
    const hasLogs = logs.length > 0;
    react_2.useEffect(() => {
        // Notify on "modal open"
        if (contentRefreshModalIsOpen && !prevContentRefreshModalIsOpen) {
            if (debug_1.OSMOSYS_IN_DEV_MODE) {
                dispatch({
                    log: {
                        level: 'debug',
                        message: 'Content refresh modal opened. Waiting...',
                    },
                    type: 'add',
                });
            }
            // Stop running on close
        }
    }, [contentRefreshModalIsOpen, prevContentRefreshModalIsOpen]);
    // Reset status
    react_2.useEffect(() => {
        if (!modalIsShowing && prevModalIsShownig) {
            setStatus('notRunning');
        }
    }, [modalIsShowing, prevModalIsShownig]);
    // Clear logs
    react_2.useEffect(() => {
        if (!modalIsShowing && prevModalIsShownig && hasLogs) {
            dispatch({
                type: 'clear',
            });
        }
    }, [modalIsShowing, prevModalIsShownig, hasLogs]);
    // Notify on "running"
    react_2.useEffect(() => {
        const run = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            if (running && !prevRunning) {
                dispatch({
                    log: {
                        level: 'info',
                        message: `Refreshing ${contentFeedsLength} content feed${contentFeedsLength === 1 ? '' : 's'} for ${blocksToRefreshCount} block${blocksToRefreshCount === 1 ? '' : 's'}...`,
                    },
                    type: 'add',
                });
                let suceeededInRun = null;
                let erroredInRun = null;
                yield contentFeeds.reduce((acc, cf) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                    const parentTimestamp = new Date();
                    const newAcc = yield acc;
                    dispatch({
                        log: {
                            level: 'info',
                            message: (react_2.default.createElement(react_2.default.Fragment, null,
                                "Requesting content feed (",
                                react_2.default.createElement("strong", null, cf.obj.name),
                                ' ',
                                react_2.default.createElement(react_router_dom_1.Link, { to: `/integrations/${cf.obj.contentSystem.id}/feeds/${cf.obj.id}`, target: "_blank" },
                                    react_2.default.createElement(react_1.OsmosysIcon, { osysIcon: "externalLink" })),
                                ") to refresh",
                                ' ',
                                react_2.default.createElement("strong", null,
                                    cf.blocks.length,
                                    " block",
                                    cf.blocks.length === 1 ? '' : 's'),
                                "...")),
                            parentTimestamp,
                        },
                        type: 'add',
                    });
                    let result;
                    try {
                        // TODO: use the useLazyQuery because aparent it returns a promise now (in v3.1.2): https://stackoverflow.com/questions/58265244/uselazyquery-not-firing-in-promise-all
                        result = yield query({
                            fetchPolicy: 'network-only',
                            query: graphql_1.contentItems,
                            variables: {
                                contentFeedId: cf.obj.id,
                                skipCache: true,
                            },
                        });
                        const contentIemObjs = result.data &&
                            result.data.contentItems &&
                            result.data.contentItems;
                        const contentItemsLength = contentIemObjs
                            ? result.data.contentItems.length
                            : 0;
                        // Update blocsk with new content
                        const newBlocksDataToSave = cf.blocks.reduce((acc, { idxPath, obj }) => {
                            if (typeof obj.contentSlotNumber !== 'number') {
                                dispatch({
                                    log: {
                                        level: 'error',
                                        message: 'Block has lost its Content Slot. Please contact support if you see this error again after retrying.',
                                    },
                                    type: 'add',
                                });
                                return acc;
                            }
                            const newContentItem = contentIemObjs[obj.contentSlotNumber];
                            const oldContentItemHash = utils_1.generateOsmosysObjectHash(obj.contentItem);
                            const newContentItemHash = utils_1.generateOsmosysObjectHash(newContentItem);
                            const contentItemHasChangedAfterRefresh = oldContentItemHash !== newContentItemHash;
                            if (!newContentItem) {
                                dispatch({
                                    log: {
                                        level: 'error',
                                        message: `No content found for slot #${obj.contentSlotNumber +
                                            1}!`,
                                    },
                                    type: 'add',
                                });
                                return acc;
                            }
                            const [newData, succeeded] = template_parser_1.updateNestedBlock(idxPath, [...acc], obj, {
                                contentFeed: cf.obj,
                                contentItem: newContentItem,
                                contentSlotNumber: typeof obj.contentSlotNumber === 'number'
                                    ? obj.contentSlotNumber
                                    : null,
                            });
                            const [titleBefore] = obj.contentItem &&
                                utils_2.getContentItemFieldData(obj.contentItem, 'title', 'No title');
                            const [linkBefore] = obj.contentItem &&
                                utils_2.getContentItemFieldData(obj.contentItem, 'link', '');
                            const [titleAfter] = obj.contentItem &&
                                utils_2.getContentItemFieldData(newContentItem, 'title', 'No title');
                            const [linkAfter] = obj.contentItem &&
                                utils_2.getContentItemFieldData(newContentItem, 'link', '');
                            dispatch({
                                log: {
                                    level: 'debug',
                                    message: (react_2.default.createElement(react_2.default.Fragment, null,
                                        react_2.default.createElement("br", null),
                                        react_2.default.createElement("span", { className: "ml-4" },
                                            "Slot #",
                                            obj.contentSlotNumber + 1,
                                            " - Before:",
                                            ' ',
                                            react_2.default.createElement("a", { href: linkBefore || undefined, target: "_blank", rel: "noopener noreferrer" }, titleBefore)),
                                        react_2.default.createElement("br", null),
                                        react_2.default.createElement("span", { className: "ml-4" },
                                            "Slot #",
                                            obj.contentSlotNumber + 1,
                                            " - After:",
                                            ' ',
                                            react_2.default.createElement("a", { href: linkAfter || undefined, target: "_blank", rel: "noopener noreferrer" }, titleAfter)))),
                                    parentTimestamp,
                                },
                                type: 'add',
                            });
                            dispatch({
                                log: {
                                    level: succeeded ? 'success' : 'warn',
                                    message: succeeded
                                        ? `Content refreshed for block using slot #${obj.contentSlotNumber +
                                            1}! ${!contentItemHasChangedAfterRefresh
                                            ? '(No changes detected)'
                                            : ''}`
                                        : 'Unable to find block to populate content with!',
                                    parentTimestamp,
                                },
                                type: 'add',
                            });
                            if (!succeeded) {
                                erroredInRun = true;
                            }
                            else if (!erroredInRun) {
                                suceeededInRun = true;
                            }
                            return newData;
                        }, [...blocks]);
                        update({
                            draftEmail: Object.assign(Object.assign({}, draftEmail), { blocks: newBlocksDataToSave }),
                        });
                        if (!erroredInRun) {
                            suceeededInRun = true;
                        }
                        // Log
                        dispatch({
                            log: {
                                level: contentItemsLength ? 'success' : 'warn',
                                message: (react_2.default.createElement(react_2.default.Fragment, null,
                                    "\u2705 Fetched ",
                                    contentItemsLength,
                                    " content item",
                                    contentItemsLength === 1 ? '' : 's',
                                    " from",
                                    ' ',
                                    react_2.default.createElement("strong", null, cf.obj.name),
                                    " for ",
                                    cf.blocks.length,
                                    " block",
                                    cf.blocks.length === 1 ? '' : 's')),
                                parentTimestamp,
                            },
                            type: 'add',
                        });
                    }
                    catch (e) {
                        erroredInRun = true;
                        dispatch({
                            log: {
                                level: 'warn',
                                message: 'Failed to fetch content feed.',
                            },
                            type: 'add',
                        });
                    }
                    return [...newAcc, result];
                }), Promise.resolve([]));
                if (erroredInRun) {
                    setStatus('error');
                }
                else if (suceeededInRun) {
                    setStatus('success');
                }
                else {
                    setStatus('error');
                }
                dispatch({
                    log: {
                        level: erroredInRun ? 'error' : suceeededInRun ? 'success' : 'warn',
                        message: erroredInRun ? (react_2.default.createElement(react_2.default.Fragment, null, "Did not fully refresh content feeds. Please review the above logs for details.")) : (react_2.default.createElement(react_2.default.Fragment, null, "\u2705 Content refreshed!")),
                    },
                    type: 'add',
                });
            }
        });
        run();
    }, [running, prevRunning]);
    const terminal = (react_2.default.createElement(OsmosysLogTerminal_1.OsmosysLogTerminal, { showSpinner: running, status: status, onClose: () => { }, logs: logs }));
    const preRunState = (react_2.default.createElement(react_1.OsmosysDiv, { padding: true, className: "text-center my-3" },
        react_2.default.createElement("h2", null, "Refresh content"),
        react_2.default.createElement("p", null,
            blocksToRefreshCount,
            " block",
            blocksToRefreshCount === 1 ? '' : 's',
            " to refresh ",
            react_2.default.createElement("span", { className: "text-muted mx-1" }, "\u2022"),
            ' ',
            contentFeedsLength,
            " content feed",
            contentFeedsLength === 1 ? '' : 's',
            " to refresh"),
        react_2.default.createElement(react_1.OsmosysDiv, { padding: true, className: "" },
            react_2.default.createElement(react_1.OsmosysButton, { disabled: !canRun, osysName: "Run", onClick: () => {
                    setStatus('loading');
                }, blurOnClick: true, osysIcon: "reload" }, canRun ? 'Refresh' : 'Nothing to refresh')),
        react_2.default.createElement(react_1.OsmosysDiv, { padding: true, className: "" },
            react_2.default.createElement(react_loops_1.For, { of: contentFeeds }, ({ obj: { name }, slots }) => {
                return (react_2.default.createElement(reactstrap_1.Card, { className: "text-left p-2" },
                    react_2.default.createElement("p", { className: "mb-1 font-weight-bold" }, name),
                    react_2.default.createElement(react_loops_1.For, { of: slots }, slotNumber => {
                        return (react_2.default.createElement(react_1.OsmosysButton, { osysName: "Slot", color: "dark", outline: true, size: "sm", disabled: true },
                            "Slot #",
                            slotNumber + 1));
                    })));
            }))));
    return (react_2.default.createElement(react_1.OsmosysModal, { isOpen: contentRefreshModalIsOpen, toggle: () => {
            update({
                contentRefreshModalIsOpen: false,
            });
        }, onClosed: () => {
            toggleModalIsShowing(false);
        }, onOpened: () => {
            toggleModalIsShowing(true);
        }, className: "" },
        react_2.default.createElement(react_1.OsmosysModal.Header, { toggle: () => {
                update({
                    contentRefreshModalIsOpen: false,
                });
            } }, "Content refresh"),
        react_2.default.createElement(react_1.OsmosysModal.Body, { className: "p-0 overflow-hidden rounded-bottom" },
            react_2.default.createElement(reactstrap_1.Collapse, { isOpen: status === 'notRunning' }, preRunState),
            react_2.default.createElement(reactstrap_1.Collapse, { isOpen: status !== 'notRunning' }, terminal))));
};
//# sourceMappingURL=index.js.map